<template>
  <div class="expected-end-of-month">
    <div class="remaining-variables container-padding">
      <div class="construction">תזרים בבניה</div>
      <div class="title">
        כמה כסף נשאר להוציא על הוצאות משתנות ב{{this.monthName}}?
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ExpectedEndOfMonth',
  computed: {
    ...mapGetters('cashflowView', ['monthName']),
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  .expected-end-of-month {
    height: 168px;
    margin-bottom: 16px;
    color: $riseup_gray_1;
    border-radius: 3px;
    border: dashed 1px $riseup_gray_1;

    .container-padding {
      padding: 5px 18px 8px 18px;;
    }

    .construction {
      font-size: 10px;
      margin-top: 14px;
    }

    .title {
      font-family: GretaSans;
      font-size: 24px;
      font-weight: bold;
      line-height: 1.00em;
      margin: 4px 0 32px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/pending-month/components/ExpectedEndOfMonth.vue